var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20Z",
    fill: "#29BBE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16528 13.1868L6.44718 10.485C6.37123 10.4091 6.33325 10.3114 6.33325 10.1921C6.33325 10.0727 6.37123 9.97505 6.44718 9.8991L7.0494 9.31316C7.12535 9.22636 7.22029 9.18296 7.33423 9.18296C7.44816 9.18296 7.54853 9.22636 7.63533 9.31316L9.45824 11.1361L13.3645 7.22983C13.4513 7.14303 13.5517 7.09962 13.6656 7.09962C13.7795 7.09962 13.8745 7.14303 13.9504 7.22983L14.5526 7.81577C14.6286 7.89172 14.6666 7.98938 14.6666 8.10874C14.6666 8.22809 14.6286 8.32575 14.5526 8.4017L9.75121 13.1868C9.67526 13.2737 9.5776 13.3171 9.45824 13.3171C9.33889 13.3171 9.24123 13.2737 9.16528 13.1868Z",
    fill: "#29BBE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.5500b3dfa37bbbb9078e7bb929982137.svg";
export { ForwardRef as ReactComponent };